const EVIDENCE_OF_REGULATION_DOCUMENT_TYPES = {
  ONLINE_REGULATORY_REGISTRY_SEARCH_RESULTS: {
    value: "online_regulatory_registry_search_results",
    readableName: "Online Regulatory Registry Search Results",
  },
  LICENSE_VERIFICATION: {
    value: "license_verification",
    readableName: "License Verification",
  },
  ONLINE_REGISTRATION_STATUS: {
    value: "online_registration_status",
    readableName: "Online Registration Status",
  },
};

export const evidenceOfRegulationDocumentTypesArray = Object.values(
  EVIDENCE_OF_REGULATION_DOCUMENT_TYPES,
);
